import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=0e6914e2&lang=less&scoped=true"

import exportComponent from "/Users/nikkizeng/Desktop/running/ph-miao-wechat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e6914e2"]])

export default __exports__